import React, { useState } from "react"
import { Space, DatePicker, Select, Input, Col } from "antd";

const AdminAuditLogFilters = ({ filters, onFiltersChange }) => {
    const [searchField, setSearchField] = useState("email")
    const searchBy = (
        <Select defaultValue="email" className="select-before" onChange={value => {
            setSearchField(value);
            onFiltersChange({ ...filters, email: undefined, username: undefined });
        }}>
            <Select.Option value="email">Email</Select.Option>
            <Select.Option value="username">Username</Select.Option>
        </Select>
    );

    return (
        <Space size="large">
            <Col>
                Search :{` `}
                <Input.Search
                    addonBefore={searchBy}
                    placeholder="Search"
                    onSearch={term => onFiltersChange({ ...filters, [searchField]: term })}
                />
            </Col>
            <Col>
                Description :{` `}
                <div>
                    <Select
                        placeholder="ALL"
                        style={{ width: 120 }}
                        allowClear
                        onChange={(value) =>
                            onFiltersChange({ ...filters, description: value })
                        }
                    >
                        {/* TODO: to create a list of admin audit log description */}
                        <Select.Option value="update">Update</Select.Option>
                    </Select>
                </div>
            </Col>
            <Col>
                Created At :{` `}
                <div>
                    <DatePicker.RangePicker
                        value={[filters.startDate, filters.endDate]}
                        onChange={(dates) =>
                            dates
                                ? onFiltersChange({
                                    ...filters,
                                    startDate: dates[0],
                                    endDate: dates[1],
                                })
                                : onFiltersChange({
                                    ...filters,
                                    startDate: undefined,
                                    endDate: undefined,
                                })
                        }
                    />
                </div>
            </Col>
        </Space>
    );
}

export default AdminAuditLogFilters;